(function () {
  var section = document.querySelector('[data-skn-ingredient-theatre]');
  if (!section) return;

  var tiles = section.querySelectorAll('[data-skn-ing-tile]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMq = window.matchMedia('(max-width: 989px)');
  var ticking = false;

  var SCROLL_VH = 9;
  var LIGHT_END = 1.1;
  var TITLE_RISE_START = 0.9;
  var TITLE_RISE_END = 2.4;
  var TILES_START = 2.8;
  var TILES_END = 8.2;
  var LIGHT_LERP = 1.35;

  var lightShown = 0;
  var lightLastTs = 0;
  var lightLoopActive = false;

  var tileScatter = [
    -28, 18, -14, 22, -20, 12, -16, 24, -10, 16, -22, 8
  ];

  function isMobile() {
    return mobileMq.matches;
  }

  function smoothstep(t) {
    return t * t * (3 - 2 * t);
  }

  function getVh() {
    return window.innerHeight;
  }

  function getScrollInto() {
    return Math.max(0, -section.getBoundingClientRect().top);
  }

  function segmentProgress(into, startVh, endVh) {
    var vh = getVh();
    var start = startVh * vh;
    var end = endVh * vh;
    if (into <= start) return 0;
    if (into >= end) return 1;
    return smoothstep((into - start) / (end - start));
  }

  function lightTarget(into) {
    return segmentProgress(into, 0, LIGHT_END);
  }

  function apply(into, light) {
    section.style.setProperty('--skn-ing-light', light.toFixed(4));

    var titleRise = segmentProgress(into, TITLE_RISE_START, TITLE_RISE_END);
    section.style.setProperty('--skn-ing-title-rise', titleRise.toFixed(3));

    var tileSpan = (TILES_END - TILES_START) / tiles.length;
    tiles.forEach(function (tile, index) {
      var start = TILES_START + index * tileSpan * 0.72;
      var end = start + tileSpan * 1.1;
      var t = segmentProgress(into, start, end);
      tile.style.setProperty('--skn-ing-tile', t.toFixed(3));
      tile.style.setProperty(
        '--skn-ing-tile-x',
        (tileScatter[index] || 0) + 'px'
      );
      tile.style.setProperty('--skn-ing-tile-travel', (getVh() * 0.72).toFixed(0) + 'px');
    });
  }

  function resetMobile() {
    lightShown = 1;
    section.style.setProperty('--skn-ing-light', '1');
    section.style.setProperty('--skn-ing-title-rise', '1');
    tiles.forEach(function (tile) {
      tile.style.setProperty('--skn-ing-tile', '1');
    });
  }

  function tick(ts) {
    if (isMobile() || reduced) {
      resetMobile();
      lightLoopActive = false;
      return;
    }

    if (!lightLastTs) lightLastTs = ts;
    var dt = Math.min((ts - lightLastTs) / 1000, 0.05);
    lightLastTs = ts;

    var into = getScrollInto();
    var target = lightTarget(into);
    var alpha = 1 - Math.exp(-LIGHT_LERP * dt);
    lightShown += (target - lightShown) * alpha;

    if (Math.abs(target - lightShown) < 0.0004) {
      lightShown = target;
    }

    apply(into, lightShown);

    if (Math.abs(target - lightShown) > 0.0004) {
      requestAnimationFrame(tick);
    } else {
      lightLoopActive = false;
    }
  }

  function onScroll() {
    if (isMobile() || reduced) {
      resetMobile();
      return;
    }

    var into = getScrollInto();
    if (lightLoopActive) {
      apply(into, lightShown);
      return;
    }

    lightLastTs = 0;
    lightLoopActive = true;
    requestAnimationFrame(tick);
  }

  if (isMobile() || reduced) {
    resetMobile();
  } else {
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', onScroll);
})();
